import { AxiosInstance, AxiosResponse } from "axios"

import { ResponseData } from "../common"

export type TestimonialSchema = {
  rating: number
  review: string
  reviewerText: string
  city: {
    [key in string]?: string
  }
}

export interface GetTestimonialsResponseData extends ResponseData {
  data: TestimonialSchema[]
}
export interface GetTestimonialsResponse extends AxiosResponse {
  data: GetTestimonialsResponseData
}

export function getTestimonialsAPI(axiosInstance: AxiosInstance) {
  return axiosInstance({
    data: { avoidClientSideAuth: true },
    method: "get",
    url: "/home/reviews",
  }) as Promise<GetTestimonialsResponse>
}
